if( ($('#from_date').length) && ($('#to_date').length) ) {
    $('#from_date').datepicker().on('changeDate', function(ev){
        var dateText = $(this).data('date'),
            endDateTextBox = $('#to_date input');
        if (endDateTextBox.val() != '') {
            var testStartDate = new Date(dateText),
                testEndDate = new Date(endDateTextBox.val());
            if (testStartDate > testEndDate) {
                endDateTextBox.val(dateText);
            }
        } else {
            endDateTextBox.text(dateText);
        };
        $('#to_date').datepicker('setStartDate', dateText);
        $('#from_date').datepicker('hide');
    });
    $('#to_date').datepicker().on('changeDate', function(ev){
        var dateText = $(this).data('date'),
            startDateTextBox = $('#from_date input');
        if (startDateTextBox.val() != '') {
            var testStartDate = new Date(startDateTextBox.val()),
                testEndDate = new Date(dateText);
            if (testStartDate > testEndDate) {
                startDateTextBox.text(dateText);
            }
        } else {
            startDateTextBox.val(dateText);
        };
        $('#from_date').datepicker('setEndDate', dateText)
        $('#to_date').datepicker('hide')
    });
}

window.Echo.private('profile.' + window.profile_guid)
    .listen('.content.certificate-generated', (e) => {
        document.getElementById('certificate-' + e.guid + '-gears').style.display = 'none';
        document.getElementById('certificate-' + e.guid + '-link').style.display = '';
    });

